<form class="main-content-container" [formGroup]="scheduleFormGroup" (ngSubmit)="onSave()">
    <r1-compass-lib-instructions-with-fields-container>
        <r1-compass-lib-instructions headerText="Default Schedule" instructions>
            Select the days, time and UTC offset to control when Plays start processing by default. Individual Plays can
            be further customized to run at different times.
        </r1-compass-lib-instructions>
        <form formArea>
            <div class="week-schedule-checkbox">
                @for (day of days; track $index) {
                    <div class="schedule-box">
                        <mat-label class="schedule-label">{{ day }}</mat-label>
                        <mat-checkbox
                            [checked]="divisionScheduleFormService.isInCheckedDays(day)"
                            (change)="divisionScheduleFormService.updateDaysOfTheWeekCheckbox($event, day)" />
                    </div>
                }
            </div>
            <r1-compass-lib-form-row name="">
                <div class="time-and-offset">
                    <mat-form-field class="time-and-offset-field">
                        <mat-label>Start Time</mat-label>
                        <input
                            [ngxMatTimepicker]="picker"
                            matInput
                            [placeholder]="'Start Time'"
                            class="time-field"
                            [value]="divisionScheduleFormService.displayTime()" />
                        <ngx-mat-timepicker
                            #picker
                            [minutesGap]="5"
                            (timeSet)="divisionScheduleFormService.transformTimeFormat($event)" />
                    </mat-form-field>

                    <mat-form-field class="time-and-offset-field">
                        <mat-label>Offset</mat-label>
                        <mat-select
                            placeholder="Offset"
                            [value]="divisionScheduleFormService.displayOffset()"
                            (selectionChange)="divisionScheduleFormService.transformOffset($event)">
                            @for (offset of offsets; track $index) {
                                <mat-option [value]="offset">
                                    {{ offset }}
                                </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>
            </r1-compass-lib-form-row>
        </form>
    </r1-compass-lib-instructions-with-fields-container>

    <r1-compass-lib-instructions-with-fields-container>
        <r1-compass-lib-instructions headerText="Pause Processing" instructions>
            Click to pause or resume processing of new executions for all plays in the division. Note: when paused,
            active executions will continue to process until complete.
        </r1-compass-lib-instructions>
        <form formArea>
            <r1-compass-lib-form-row name="">
                <div class="left-aligned-content">
                    <button mat-flat-button class="pause-button" type="button" (click)="onTogglePause()">
                        <span [class]="pausedStatusClass()">
                            {{ pausedStatusLabel() }}
                        </span>
                    </button>
                </div>
            </r1-compass-lib-form-row>
        </form>
    </r1-compass-lib-instructions-with-fields-container>

    <r1-compass-app-save-division-settings-footer [disabled]="divisionScheduleFormService.saveDisabled()" />
</form>
